/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import MoserObjectUtils from './MoserObjectUtils';
import CardinalityEnum from './CardinalityEnum';
import SqlOperatorType from './SqlOperatorType';
import KeyConstraintType from './KeyConstraintType';
import KeyCompositionType from './KeyCompositionType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // updateShortcutAddAt, updateShortcutRemoveAt, updateShortcutSet
//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityEnum (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlOperatorType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyConstraintType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyCompositionType (runtime) // new

/**
 * <p>Java class for itemNormalizationGroupType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="itemNormalizationGroupType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="parentGroupRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="cardinality" type="{}cardinalityEnum"/&gt; &lt;element name="key" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyConstraint" type="{}keyConstraintType"/&gt; &lt;element name="keyComposition" type="{}keyCompositionType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="attribute" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="sqlOperator" type="{}sqlOperatorType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ItemNormalizationGroupType extends ObjectType{

	parentGroupRef = null;

	cardinality = null;

	key = null;

	attribute = null;



	/**
	 * Gets the value of the parentGroupRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parentGroupRef property. <p> For example, to add a new item, do as follows: <pre> getParentGroupRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getParentGroupRef() {
		if (!this.parentGroupRef) {
			this.parentGroupRef = [];
		}
		return this.parentGroupRef;
	}

	/**
	 * Gets the value of the cardinality property.
	 * @return {CardinalityEnum} possible object is {@link CardinalityEnum}
	 */
	getCardinality() {
		return this.cardinality;
	}

	/**
	 * Sets the value of the cardinality property.
	 * @param {CardinalityEnum} value allowed object is {@link CardinalityEnum}
	 */
	setCardinality(value) {
		var oldValue = this.cardinality;
		this.cardinality = value;
		this._setAndNotify(86, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the key property.
	 * @return {Key} possible object is {@link ItemNormalizationGroupType.Key}
	 */
	getKey() {
		return this.key;
	}

	/**
	 * Sets the value of the key property.
	 * @param {Key} value allowed object is {@link ItemNormalizationGroupType.Key}
	 */
	setKey(value) {
		var oldValue = this.key;
		this.key = value;
		this._setAndNotify(87, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the attribute property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the attribute property. <p> For example, to add a new item, do as follows: <pre> getAttribute().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemNormalizationGroupType.Attribute}
	 */
	getAttribute() {
		if (!this.attribute) {
			this.attribute = [];
		}
		return this.attribute;
	}

	/**
	 * Gets the value of the <code>parentGroupRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetParentGroupRef() {
		return this.parentGroupRef;
	}

	/**
	 * Gets the value of the <code>attribute</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Attribute</code> elements, or <code>null</code> if not set
	 */
	basicGetAttribute() {
		return this.attribute;
	}

	/**
	 * Creates a new instance of <code>ItemNormalizationGroupType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ItemNormalizationGroupType</code> object from.
	 * @return {ItemNormalizationGroupType} an object of type <code>ItemNormalizationGroupType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemNormalizationGroupType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addParentGroupRefAt(position, item) {
		this._addAtAndNotify(this.getParentGroupRef(), position, item, 85, false, false);
		MoserObjectUtils.updateShortcutAddAt(this, 85, position, item);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addParentGroupRef(item) {
		this.addParentGroupRefAt(this.getParentGroupRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeParentGroupRefAt(position) {
		this._removeAtAndNotify(this.getParentGroupRef(), position, 85, false);
		MoserObjectUtils.updateShortcutRemoveAt(this, 85, position);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeParentGroupRef(item) {
		var i = this.getParentGroupRef().indexOf(item);
		if (i >= 0) {
			this.removeParentGroupRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addAttributeAt(position, item) {
		this._addAtAndNotify(this.getAttribute(), position, item, 88, true, false);
		MoserObjectUtils.updateShortcutAddAt(this, 88, position, item);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addAttribute(item) {
		this.addAttributeAt(this.getAttribute().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeAttributeAt(position) {
		this._removeAtAndNotify(this.getAttribute(), position, 88, true);
		MoserObjectUtils.updateShortcutRemoveAt(this, 88, position);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeAttribute(item) {
		var i = this.getAttribute().indexOf(item);
		if (i >= 0) {
			this.removeAttributeAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ItemNormalizationGroupType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 85, "parentGroupRef", null));
		featureList.push(this.createFeature(false, true, false, 86, "cardinality", CardinalityEnum));
		var clazz;
		if (factory) {
			clazz = factory.createItemNormalizationGroupTypeKey().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 87, "key", clazz));
		if (factory) {
			clazz = factory.createItemNormalizationGroupTypeAttribute().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 88, "attribute", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 86:
			this.setCardinality((value));
			break;
		case 87:
			this.setKey((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 85:
			this.parentGroupRef = (value);
			break;
		case 88:
			this.attribute = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 85:
			return this.getParentGroupRef();
		case 86:
			return this.getCardinality();
		case 87:
			return this.getKey();
		case 88:
			return this.getAttribute();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 85:
			return this.basicGetParentGroupRef();
		case 86:
			return this.getCardinality();
		case 87:
			return this.getKey();
		case 88:
			return this.basicGetAttribute();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 85:
			this.addParentGroupRefAt(position, (value));
			break;
		case 88:
			this.addAttributeAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 85:
			this.addParentGroupRef((value));
			break;
		case 88:
			this.addAttribute((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 85:
			this.removeParentGroupRefAt(position);
			break;
		case 88:
			this.removeAttributeAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 85:
			this.removeParentGroupRef((item));
			break;
		case 88:
			this.removeAttribute((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="sqlOperator" type="{}sqlOperatorType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ItemNormalizationGroupType.Attribute = class extends MoserObject{

	itemRef = null;

	sqlOperator = null;



	/**
	 * Gets the value of the itemRef property.
	 * @return {String} possible object is {@link String}
	 */
	getItemRef() {
		return this.itemRef;
	}

	/**
	 * Sets the value of the itemRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setItemRef(value) {
		var oldValue = this.itemRef;
		this.itemRef = value;
		this._setAndNotify(284, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 284, oldValue, value);
	}

	/**
	 * Gets the value of the sqlOperator property.
	 * @return {SqlOperatorType} possible object is {@link SqlOperatorType}
	 */
	getSqlOperator() {
		return this.sqlOperator;
	}

	/**
	 * Sets the value of the sqlOperator property.
	 * @param {SqlOperatorType} value allowed object is {@link SqlOperatorType}
	 */
	setSqlOperator(value) {
		var oldValue = this.sqlOperator;
		this.sqlOperator = value;
		this._setAndNotify(287, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 287, oldValue, value);
	}

	/**
	 * Creates a new instance of <code>Attribute</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Attribute</code> object from.
	 * @return {Attribute} an object of type <code>Attribute</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemNormalizationGroupTypeAttribute();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Attribute";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 284, "itemRef", null));
		featureList.push(this.createFeature(false, true, false, 287, "sqlOperator", SqlOperatorType));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 284:
			this.setItemRef((value));
			break;
		case 287:
			this.setSqlOperator((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 284:
			return this.getItemRef();
		case 287:
			return this.getSqlOperator();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 284:
			return this.getItemRef();
		case 287:
			return this.getSqlOperator();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyConstraint" type="{}keyConstraintType"/&gt; &lt;element name="keyComposition" type="{}keyCompositionType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ItemNormalizationGroupType.Key = class extends MoserObject{

	itemRef = null;

	keyConstraint = null;

	keyComposition = null;



	/**
	 * Gets the value of the itemRef property.
	 * @return {String} possible object is {@link String}
	 */
	getItemRef() {
		return this.itemRef;
	}

	/**
	 * Sets the value of the itemRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setItemRef(value) {
		var oldValue = this.itemRef;
		this.itemRef = value;
		this._setAndNotify(284, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 284, oldValue, value);
	}

	/**
	 * Gets the value of the keyConstraint property.
	 * @return {KeyConstraintType} possible object is {@link KeyConstraintType}
	 */
	getKeyConstraint() {
		return this.keyConstraint;
	}

	/**
	 * Sets the value of the keyConstraint property.
	 * @param {KeyConstraintType} value allowed object is {@link KeyConstraintType}
	 */
	setKeyConstraint(value) {
		var oldValue = this.keyConstraint;
		this.keyConstraint = value;
		this._setAndNotify(285, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 285, oldValue, value);
	}

	/**
	 * Gets the value of the keyComposition property.
	 * @return {KeyCompositionType} possible object is {@link KeyCompositionType}
	 */
	getKeyComposition() {
		return this.keyComposition;
	}

	/**
	 * Sets the value of the keyComposition property.
	 * @param {KeyCompositionType} value allowed object is {@link KeyCompositionType}
	 */
	setKeyComposition(value) {
		var oldValue = this.keyComposition;
		this.keyComposition = value;
		this._setAndNotify(286, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 286, oldValue, value);
	}

	/**
	 * Creates a new instance of <code>Key</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Key</code> object from.
	 * @return {Key} an object of type <code>Key</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemNormalizationGroupTypeKey();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Key";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 284, "itemRef", null));
		featureList.push(this.createFeature(false, true, false, 285, "keyConstraint", KeyConstraintType));
		featureList.push(this.createFeature(false, true, false, 286, "keyComposition", KeyCompositionType));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 284:
			this.setItemRef((value));
			break;
		case 285:
			this.setKeyConstraint((value));
			break;
		case 286:
			this.setKeyComposition((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 284:
			return this.getItemRef();
		case 285:
			return this.getKeyConstraint();
		case 286:
			return this.getKeyComposition();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 284:
			return this.getItemRef();
		case 285:
			return this.getKeyConstraint();
		case 286:
			return this.getKeyComposition();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ItemNormalizationGroupType.js